module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMiIgaGVpZ2h0PSIxMiIgdmlld0JveD0iMCAwIDEyIDEyIiBmaWxsPSJub25lIj4KICA8cGF0aCBkPSJNNS43NSAxMS41QzIuNTc5MzQgMTEuNSAwIDguOTIwNTMgMCA1Ljc1QzAgMi41Nzk0NyAyLjU3OTM0IDAgNS43NSAwQzguOTIwNjYgMCAxMS41IDIuNTc5NDcgMTEuNSA1Ljc1QzExLjUgOC45MjA1MyA4LjkyMDY2IDExLjUgNS43NSAxMS41WiIgZmlsbD0id2hpdGUiLz4KICA8cGF0aCBkPSJNNC43NSA4LjQ1NzE2TDIuMDQyOTcgNS43NUwyLjc1IDUuMDQyODVMNC43NSA3LjA0Mjg1TDguNzUgMy4wNDI4NUw5LjQ1NzAzIDMuNzVMNC43NSA4LjQ1NzE2WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+"


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobile/icon/check-circle.svg
// module id = 315
// module chunks = 180